import React from 'react';

export default function InputLabel(props: { label: string }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div
        style={{
          paddingBottom: 5,
          fontSize: 12,
          fontWeight: 600,
          color: '#777777',
          paddingLeft: 2,
        }}
      >
        {props.label}
      </div>
      {props.children}
    </div>
  );
}
